// Notification languages control Telegram + push notification language only.
// This is DISTINCT from the web UI language (see contexts/I18nContext + i18n/).
// The canonical list of codes comes from the backend (GET /api/languages);
// we map each code to a native display label here.

export const NOTIFY_LANG_LABELS = {
  en: 'English',
  es: 'Español (España)',
  'es-419': 'Español (Latinoamérica)',
  fr: 'Français',
  pt: 'Português (Portugal)',
  'pt-BR': 'Português (Brasil)',
  et: 'Eesti',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  pl: 'Polski',
  uk: 'Українська',
  ru: 'Русский',
  it: 'Italiano',
};

// Used until GET /api/languages resolves (or if it's unreachable), so the
// dropdowns are never empty. Kept in sync with the backend's known codes.
export const NOTIFY_LANG_FALLBACK = [
  'en', 'es', 'es-419', 'fr', 'pt', 'pt-BR', 'et', 'lt', 'lv', 'pl', 'uk', 'ru', 'it',
];

export const notifyLangLabel = (code) => NOTIFY_LANG_LABELS[code] || code || 'en';
